export default "__VITE_ASSET__DAHt5D3s__"